module.exports = __webpack_public_path__ + "static/BackgroundHowItWorks-3cc2eff480ee511ae8c19811d1f594ae.png";